@if (layerService.showLegend()) {
  <app-small-dialog-container
    [title]="'Title.SubTitle.Legend' | transloco"
    (closeDialogClicked)="hideLegend()"
    [position]="legendPosition()"
  >
    <div class="flex flex-col">
      <div class="flex flex-row justify-between items-center mb-4">
        <div>
          <mat-icon [svgIcon]="'icn-settings'" class="!h-[12px] !w-[12px] mr-2" />
          <span>
            {{ "Module.Layer.ShowDistrict" | transloco }}
          </span>
        </div>
        <mat-slide-toggle [ngModel]="layerService.showDistrict()" (ngModelChange)="ActivateBorder()" hideIcon="true" />
      </div>
      @for (legendItem of legends() | keyvalue; track legendItem) {
        <div class="mb-2 last:mb-0">
          <app-info-expansion-panel [title]="legendItem.value.displayName" class="legend-panel">
            @if (legendItem.value.unit) {
              <div class="flex justify-between items-center mb-2">
                <span class="text-sm font-semibold">{{ legendItem.value.unit }}</span>
              </div>
            }
            @if (!legendItem.value.colorRamp) {
              @for (item of legendItem.value.layerLegend; track item) {
                <div class="flex items-center space-x-2 mb-1">
                  @if (item.iconUrl !== null) {
                    <img
                      class="w-5 h-5"
                      alt="Legend-Icon"
                      ngSrc="{{ item.iconUrl }}"
                      width="5"
                      height="5"
                      [style.background-color]="item.color"
                    />
                  }
                  <div class="w-5 h-5" [style.background-color]="item.color"></div>
                  <div>{{ item.displayText }}</div>
                </div>
              }
            }
            @if (legendItem.value.colorRamp) {
              <app-color-ramp
                [colors]="getColorRamp(legendItem.value.layerLegend)"
                [minValue]="legendItem.value.layerLegend[0].displayText || legendItem.value.layerLegend[0].value"
                [maxValue]="
                  legendItem.value.layerLegend[legendItem.value.layerLegend.length - 1].displayText ||
                  legendItem.value.layerLegend[legendItem.value.layerLegend.length - 1].value
                "
              />
            }
          </app-info-expansion-panel>
        </div>
      }
    </div>
  </app-small-dialog-container>
}
